export const ICustomer = {
  id: 4,
  is_active: true,
  images: [],
  image_type: 0,
  title: 'Mr.',
  first_name: 'Reza',
  surname: 'Samiei2',
  date_of_birth: '1990-01-01T00:00:00.000Z',
  gender: 'Male',
  customer_group_id: 1,
  business_name: 'Doe Enterprises',
  tax_number: 'TX12345B',
  email: 'rezasamiei@example.com',
  contact_number: '+1234567890',
  contact_number_code: '+1',
  address: {
    line1: 'line1',
    line2: 'line2',
    city: 'city',
    country: 'country',
    postcode: 'postcode',
  },
  gdpr_email: true,
  gdpr_sms: false,
  credit_limit: '2.000',
  daily_transaction_limit: '3.000',
  note: 'This is note',
  last_user_id: 15,
  created_at: '2024-01-02T21:50:31.981Z',
}

export const ICustomerUpsertArgs = {
  id: 0,
  first_name: 'John',
  surname: 'Doe',
  title: 'Mr.',
  gender: 'Male',
  date_of_birth: '1990-01-01',
  customer_group_id: 1,
  business_name: 'Doe Enterprises',
  tax_number: 'TX12345B',
  email: 'someone@example.com',
  contact_number: '+1234567890',
  contact_number_code: '+1',
  address: {
    line1: 'line1',
    line2: 'line2',
    city: 'city',
    country: 'country',
    postcode: 'postcode',
  },
  gdpr_email: true,
  gdpr_sms: false,
  credit_limit: 2,
  daily_transaction_limit: 3,
  note: 'This is note',
}
